<template>
    <div class="ies-field">

        <!-- Label -->
        <div v-if="field.schema && field.schema.displayName !== 'none'" class="ies-field__label mb-1">
            <label :for="field.fieldName" class="font-weight-heavy">
                {{ field.schema.displayName }}<span v-if="field.required" class="red--text ml-1" title="Required">*</span>
            </label>
            <v-icon
                v-if="hasValidation"
                small
                class="ml-1"
                style="cursor: pointer; vertical-align: middle"
                @click="showValidationGuide = !showValidationGuide"
                title="Show validation rules"
            >info_outline</v-icon>
        </div>

        <!-- Validation guide -->
        <v-alert v-if="showValidationGuide && hasValidation" type="info" dense class="mb-2">
            <div v-for="(rule, i) in field.validation" :key="i">{{ ruleAsString(rule) }}</div>
        </v-alert>

        <!-- Introduction text -->
        <div v-if="field.introduction" class="body-2 grey--text text--darken-1 mb-2">{{ field.introduction }}</div>

        <!-- Info alert -->
        <v-alert v-if="field.information" type="info" dense dismissible class="mb-2">{{ field.information }}</v-alert>

        <!-- Warning alert -->
        <v-alert v-if="warningText" type="warning" dense dismissible class="mb-2">{{ warningText }}</v-alert>

        <!-- Error messages -->
        <v-alert v-if="normalisedErrors.length" type="error" dense class="mb-2">
            <div v-for="(msg, i) in normalisedErrors" :key="i">{{ msg }}</div>
        </v-alert>

        <!-- Input control -->
        <slot></slot>

    </div>
</template>

<script>
export default {
    name: 'ies-form-field',
    props: ['field'],

    data() {
        return {
            showValidationGuide: false,
            eventErrors: [],
        };
    },

    mounted() {
        const self = this;
        this.$root.$on('Field: set errors', function (payload) {
            if (payload.modelName === self.field.modelName && payload.fieldName === self.field.fieldName) {
                self.eventErrors = payload.errors || [];
            }
        });
        this.$root.$on('Field: clear errors', function (payload) {
            if (payload.modelName === self.field.modelName && payload.fieldName === self.field.fieldName) {
                self.eventErrors = [];
            }
        });
    },

    computed: {
        hasValidation() {
            return this.field.validation && this.field.validation.length;
        },

        warningText() {
            return this.field.warning || this.field.warnings || null;
        },

        normalisedErrors() {
            const msgs = [];
            if (this.eventErrors && this.eventErrors.length) {
                this.eventErrors.forEach(e => msgs.push(e.reason || e));
            }
            if (!msgs.length && this.field.errors) {
                const errs = this.field.errors;
                if (Array.isArray(errs)) errs.forEach(e => msgs.push(e));
                else if (typeof errs === 'string') msgs.push(errs);
            }
            if (!msgs.length && this.field.error) {
                msgs.push(this.field.error);
            }
            return msgs;
        },
    },

    methods: {
        ruleAsString(rule) {
            switch (rule.ruleType) {
                case 'minLength': return `Must be at least ${rule.value} characters`;
                case 'maxLength': return `Must not exceed ${rule.value} characters`;
                case 'minValue':  return `Must be greater than ${rule.value}`;
                case 'maxValue':  return `Must be less than ${rule.value}`;
                case 'notEmpty':  return 'This field must not be empty';
                case 'regExp':    return `Pattern: ${rule.value}`;
                default:          return `${rule.ruleType} ${rule.value}`;
            }
        },
    },
};
</script>

<style scoped>
.ies-field__label label {
    font-size: 0.875rem;
    line-height: 1.4;
}
</style>
